export default __webpack_public_path__ + "media/images/settings_32-a6fd29f51c3acad0672b5c8b138c4dfc.png";